import styled from "styled-components";

export const Wrapper = styled.div`
  font-family: sans-serif;
  text-align: center;
  font-size: 1em;
  border-radius:10px;
`;

export const Pre = styled.pre`
  text-align: left;
  font-size: 0.8em;
  margin: 1em 0;
  padding: 0.5em;
  overflow: auto;
  border-radius:10px;

  & .token-line {
    line-height: 1.3em;
    height: 1.3em;
  }
`;

export const Line = styled.div`
  display: table-row;
`;

export const LineNo = styled.span`
  display: table-cell;
  text-align: right;
  padding-right: 1em;
  user-select: none;
  opacity: 0.5;
  font-size: 1em;
`;

export const LineContent = styled.span`
  display: table-cell;
`;
